import { getCloudUrl } from "Constants";
import { colors } from "@toddle-edu/ds-theme";

const worksheetCloudUrl = `${getCloudUrl()}/assets/worksheet`;

export const TEXT_ELEMENT_CONFIG = {
  fontSize: 16,
  color: colors.textDefault,
  padding: 14,
  fontStyle: "500",
  fontFamily: "Avenir Next",
  WRAPPER_FILL: colors.surfaceWhite,
  WRAPPER_SHADOW: "rgba(0, 46, 57, 0.25)",
  WRAPPER_STROKE: colors.borderDefault,
  WRAPPER_STROKE_WIDTH: 1,
  WRAPPER_SHADOW_BLUR: 18,
  WRAPPER_SHADOW_OFFSETX: 0,
  WRAPPER_SHADOW_OFFSETY: 9,
  WRAPPER_CORNER_RADIUS: 4,
  TEXT_EDITING_SPACE: 8,
  PLACEHOLDER_FILL: colors.textPlaceholder,
};

export const IMAGE_ELEMENT_CONFIG = {
  SHADOW_BLUR: 18,
  SHADOW_OFFSETX: 0,
  SHADOW_OFFSETY: 9,
  CORNER_RADIUS: 0,
  DRAG_CORNER_RADIUS: 8,
  DEFAULT_SIZE: 75,
  STROKE_WIDTH: 0.1,
  STROKE_COLOR: "rgba(0, 46, 57, 0.25)",
};

export const ELLIPSE_ELEMENT_CONFIG = {
  DEFAULT_RADIUS: 50,
  STROKE_WIDTH: 3.5,
  STROKE_COLOR: colors.borderDark,
  DRAW_MODE_STROKE_COLOR: colors.borderLink,
  DRAW_MODE_STROKE_WIDTH: 1,
};

export const RECTANGLE_ELEMENT_CONFIG = {
  DEFAULT_SIZE: 75,
  STROKE_WIDTH: 3.5,
  STROKE_COLOR: colors.borderDark,
  DRAW_MODE_STROKE_COLOR: colors.borderLink,
  DRAW_MODE_STROKE_WIDTH: 1,
};

export const POLYGON_ELEMENT_CONFIG = {
  DEFAULT_POINTS: [50, 50, 100, 100, 150, 150],
  STROKE_WIDTH: 3.5,
  STROKE_COLOR: colors.borderDark,
  DRAW_MODE_STROKE_COLOR: colors.borderLink,
  DRAW_MODE_STROKE_WIDTH: 1,
  DRAW_MODE_WHITE: colors.white,
  DRAWING_CURSOR_SRC: `${worksheetCloudUrl}/polygon-cursor.svg`,
};

export const TRANFORMER_CONFIG = {
  STROKE: colors.blue400,
  ANCHORFILL: colors.surfaceWhite,
  BORDER_WIDTH: 1.5,
  ANCHOR_SIZE: 14,
};

export const EVALUATION_MODE_CONFIG = {
  CORRECT_ANSWER_SRC: `${worksheetCloudUrl}/TickCircleFilled.svg`,
  WRONG_ANSWER_SRC: `${worksheetCloudUrl}/CloseCircleFilled.svg`,
  CORRECT_ANSWER_STROKE: colors.teal400,
  WRONG_ANSWER_STROKE: colors.red52,
  TEXT_STROKE_WIDTH: 1,
  IMAGE_STROKE_WIDTH: 3,
  CORRECT_ANSWER_FILL: colors.teal950,
  WRONG_ANSWER_FILL: "#FFF6F3",
};

export const HOTSPOT_CONFIG = {
  CORRECT_HOTSPOT_FILL: colors.surfaceOnLink,
  STUDENT_HOTSPOT_FILL: colors.decorativeSurfaceTwo,
  ACTIVE_HOTSPOT_FILL: "rgba(136, 136, 242, 0.40)",
  SELECTED_HOTSPOT_FILL: "rgba(71, 206, 172, 0.40)",
  CORRECT_HOTSPOT_BOOKMARK_SRC: `${worksheetCloudUrl}/TickCircleFilledBookMarker.svg`,
  WRONG_HOTSPOT_BOOKMARK_SRC: `${worksheetCloudUrl}/CloseCircleFilledBookMarker.svg`,
  MARKED_HOTSPOT_BOOKMARK_SRC: `${worksheetCloudUrl}/PurpleTickBookMark.svg`,
};

export const LABEL_CONFIG = {
  FILLED_ARROW_SRC: `${worksheetCloudUrl}/green-arrow-circle.svg`,
  OUTLINE_GRAY_ARROW_SRC: `${worksheetCloudUrl}/GrayForwardArrow.svg`,
  ARROW_STROKE_WIDTH: 3.5,
};
